import React, { useState, useEffect } from "react";
import store from "store";
import { imageMediaUrl } from "util/config";
import "./index.css";

const menuItems = [
  { label: "Home", route: "/trainee", icon: "BookOpen.png" },
  { label: "My Courses",  route: "/trainee-courses", icon: "Graduation-cap.png" },
  { label: "Track Progress",  route: "/trainee-progress", icon: "graph-bar-increase.png" },
  { label: "Leaderboard",  route: "/trainee-leaderboard", icon: "Trophy.png" },
  { label: "Schedule",  route: "/trainee-schedule", icon: "calender.png" },
  { label: "Phishing Campaigns",  route: "/trainee/phishing-campaigns", icon: "BookOpen.png", requiresManager: true },
  { label: "Training Campaigns",  route: "/trainee/training-campaigns", icon: "Graduation-cap.png", requiresManager: true },
];

const SideNavbar = (props) => {
  const [selected, setSelected] = useState(
    localStorage.getItem("selectedMenu") || "Home"
  );
  const { location } = props;
  console.log(location,'location')

  var userInfo = store.get("user");

  console.log(userInfo,'userInfo.organisation',store.get("accessToken"))

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isReportingManager, setIsReportingManager] = useState(() => {
    // Initialize from localStorage cache for instant display
    const cached = localStorage.getItem("isReportingManager");
    return cached === "true";
  });

  const checkIsReportingManager = async () => {
    const apiUrl = process.env.REACT_APP_API_URL || "";
    const email = (userInfo && userInfo.email) ? userInfo.email : "";
    const url = `${apiUrl}api/reporting/is-manager?email=${encodeURIComponent(email)}`;
    const accessToken = localStorage.getItem("accessToken");

    try {
      const res = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + accessToken,
          "Content-Type": "application/json",
        },
      });

      if (!res.ok) {
        if (res.status === 401) {
          localStorage.clear();
          window.location.reload();
          throw new Error("Session expired");
        } else {
          throw new Error("API error");
        }
      }

      const data = await res.json();
      console.log("Reporting manager API response status:", data);
      if (!data.error && data.data) {
        console.log("Reporting manager status:", data.data.isReportingManager);
        const isManager = data.data.isReportingManager || false;
        setIsReportingManager(isManager);
        // Cache the value in localStorage for instant loading next time
        localStorage.setItem("isReportingManager", isManager.toString());
      }
    } catch (err) {
      if (err.message !== "Session expired" && err.message !== "API error") {
        console.error("Failed to check reporting manager status:", err);
      }
    }
  };

  useEffect(() => {
    const stored = localStorage.getItem("selectedMenu");
    if (stored && stored !== selected) setSelected(stored);
    checkIsReportingManager();
  }, []);
  const handleMenuClick = (label) => {
    setSelected(label);
    setIsSidebarOpen(false);
    localStorage.setItem("selectedMenu", label);

    switch (label) {
      case "Home":
        window.location.href = "/trainee";
        break;
      case "My Courses":
        window.location.href = "/trainee-courses";
        break;
      case "Track Progress":
        window.location.href = "/trainee-progress";
        break;
      case "Leaderboard":
        window.location.href = "/trainee-leaderboard";
        break;
      case "Schedule":
        window.location.href = "/trainee-schedule";
        break;
      case "Phishing Campaigns":
        window.location.href = "/trainee/phishing-campaigns";
        break;
      case "Training Campaigns":
        window.location.href = "/trainee/training-campaigns";
        break;

      default:
        break;
    }
  };
  return (
    <>
      <button
        className="sidebar-toggle"
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
      >
        ☰
      </button>

      <div className={`side-navbar ${isSidebarOpen ? "open" : ""}`}>
        <div className="profile-section">
          <img
           src={
            userInfo.profilePhoto && userInfo.profilePhoto !== ""
              ? `${imageMediaUrl}${userInfo.profilePhoto}?token=${store.get("accessToken")}`
              : require("assets/images/avatures/avature-2.png")
          }
          alt=""
          className="uk-border-circle" style={{width:"120px",height:"120px"}}
          />
        </div>

        <ul className="menu">
          {menuItems.map((item) => {
            if((item.label == "Leaderboard" && !userInfo.organisationId.showLeaderBoard) || (item.label == "Track Progress" && userInfo.organisationId.hideTrackProgress))
              return false;
            if(item.requiresManager && !isReportingManager)
              return false;
            return(<li
              key={item.label}
              className={`menu-item ${
                item.route === location.pathname ? "selected" : ""
              }`}
              onClick={() => handleMenuClick(item.label)}
            >
              <img
                className={`icon-image ${
                  item.route === location.pathname ? "selected" : ""
                }`}
                src={`/assets/${
                  item.route === location.pathname
                    ? item.icon.replace(".png", "_dark.png")
                    : item.icon
                }`}
                alt={item.label}
              />
              <span className="label">{item.label}</span>
            </li>)
        })}
        </ul>
      </div>
    </>
  );
};

export default SideNavbar;
